/**
 * Univen brand tokens for jopi.
 *
 * jopi only ships Tokko Broker and accepts a brand object at runtime. Mirrors
 * tokkobroker-react `src/theme/brands/univen.js`; keep both in sync.
 *
 * `name` must match THEMES.UNIVEN, which jopi writes to <html data-theme>.
 */
const JOPI_UNIVEN_BRAND = {
  name: "univen",
  colors: {
    primary: "#0046D2",
    primaryHover: "#0038A8",
    primaryPressed: "#002A7E",
    primaryAccent: "#CCDAF6",
    secondary: "#062756",
    secondaryHover: "#2A4A77",
    secondaryPressed: "#4F6D98",
    petrokoPressed: "#2A4A77",
    petrokoHeader: "#062756",
    badgeOnBrand: "var(--color-brand-badges-background)",
    badgeOnBrandText: "#FFFFFF",
  },
  fontFamily: '"Oatmeal Pro", "Nunito Sans", sans-serif',
};

export default JOPI_UNIVEN_BRAND;
